export default "__VITE_ASSET__C7etphQ2__"